import "./App.css";
import Inicio from "./screens/Inicio";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Emergency from "./screens/Emergency";
import ErrorPage from "./screens/ErrorPage";
import SecureForm from "./screens/SecureForm";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <BrowserRouter>
          <Routes>
            <Route element={<Inicio />} path="/" errorElement={<ErrorPage />} />
            <Route element={<Emergency />} path={"/emergencias"} />
            <Route element={<SecureForm />} path={"/formulario_seguro"} />
          </Routes>
        </BrowserRouter>
      </header>
    </div>
  );
}

export default App;
